/* eslint-disable import/no-unresolved */
import { bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux/actions";

import ContextMenu from "pages/_components/ContextMenu";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import InfoTag from "pages/_components/InfoTag";

import * as accountUtils from "util/accounts";
import * as i18nUtils from "util/i18n";
import * as thirdPaymentUtils from "util/thirdPayment";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions } from "reducers/form";
import { selectors as transactionLinesSelectors } from "reducers/form/transactionLines";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";

import moment from "moment";
import Card from "pages/_components/Card/Card";
import CardContainer from "pages/_components/Card/CardContainer";
import I18n from "pages/_components/I18n";
import { actions as notificationActions } from "reducers/notification";
import * as configUtils from "util/config";
import ThirdPaymentCancelData from "./ThirdPaymentCancelData";

class ThirdPaymentItem extends Component {
    static propTypes = {
        accounts: shape({}),
        loggedUser: shape({
            userId: string.isRequired,
        }).isRequired,
        request: shape({}).isRequired,
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
    };

    static defaultProps = {
        accounts: null,
    };

    componentDidMount() {
        const { dispatch, loggedUser, accounts } = this.props;

        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
    }

    isCancellationTimeValid = () => {
        const extractHourStr = configUtils.get("payment.process.hour", "13:00:00");
        const allowedPeriodMin = configUtils.getInteger("frontend.paymentThirdParties.allowedperiod", 30);
        const extractTime = moment(extractHourStr, "HH:mm:ss");
        const deadline = moment(extractTime).subtract(allowedPeriodMin, "minutes");
        return moment().isBefore(deadline);
    };

    cancelTransaction = () => {
        const paymentThirdPartiesFunctionalities = configUtils.getBoolean(
            "frontend.show.paymentThirdParties.functionalities",
            false,
        );
        const { request, dispatch, accounts } = this.props;
        const { transaction, transactionOrder, idTransactionStatus } = request;
        // Validacion de periodo de cancelacion
        if (paymentThirdPartiesFunctionalities && transaction?.idTransactionStatus === "PROCESSING") {
            const canAnular = this.isCancellationTimeValid();
            if (!canAnular) {
                const errorMsj = configUtils.get("frontend.paymentThirdParties.Tooltip.ERROR");
                dispatch(notificationActions.showNotification(errorMsj, "error", "forms"));
                return;
            }
        }
        let accountName = null;
        const numberAccount = transaction.data.debitAccount;
        if (accounts.length > 0) {
            const loggedUserAccount = accounts.find((account) => numberAccount.includes(account?.idProduct));
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }

        const cancelTransactionData = (
            <ThirdPaymentCancelData
                transactionOrder={transactionOrder}
                code={transaction.transactionStatusName || thirdPaymentUtils.getCodeMsg(idTransactionStatus)}
                summary={transaction}
                accountName={accountName}
            />
        );

        dispatch(push("/transactions/cancel"));
        dispatch(
            formActions.cancelTransactionData({
                idTransaction: transaction?.idTransaction,
                content: cancelTransactionData,
                title: "activities.thirdpay.table.menu.decline",
                ...(paymentThirdPartiesFunctionalities &&
                    transaction?.idTransactionStatus === "PROCESSING" && { force: true }),
            }),
        );
        dispatch(formActions.cancelTransactionPre({ idActivity: "pay.multiline.send", idForm: "" }));
        dispatch(thirdPaymentActions.loadConfirmThirdPayment({ ...transaction, action: "cancel" }));
    };

    getStatusTransaction = () => {
        const { request } = this.props;
        return thirdPaymentUtils.getThirdPaymentDisplayStatus(request.transaction);
    };

    getItemsContextMenuMobile = () => {
        const { request, dispatch, accounts } = this.props;
        const { transaction } = request;
        const { data, idTransaction, idTransactionStatus } = transaction;
        const { transactionOrder } = request;
        const { debitAccount, amount } = data;
        const paymentThirdPartiesFunctionalities = configUtils.getBoolean(
            "frontend.show.paymentThirdParties.functionalities",
            false,
        );
        let accountName = null;
        const numberAccount = debitAccount;
        if (accounts.length > 0) {
            const loggedUserAccount = accounts.find((account) => numberAccount.includes(account?.idProduct));
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }

        const items = [];
        if (
            idTransactionStatus === "PENDING" ||
            (paymentThirdPartiesFunctionalities && idTransactionStatus === "PROCESSING")
        ) {
            items.push({
                label: "thirdPayments.decline",
                onClick: () => {
                    dispatch(thirdPaymentActions.setPageToGoBack("/payThirdParties/list"));
                    dispatch(thirdPaymentActions.getTransaction(idTransaction));
                    this.cancelTransaction();
                },
                icon: "Error",
            });
            items.push({
                label: "thirdPayments.download.detail",
                onClick: () => {
                    dispatch(
                        thirdPaymentActions.downloadFileTransaction(
                            "pdf",
                            [],
                            data.typePayment,
                            data.file[0].fileName,
                            idTransaction,
                            data.reference,
                            data.dateProcess,
                            transactionOrder,
                            amount?.currency,
                            idTransactionStatus,
                            accountName,
                            this.getStatusTransaction(),
                            data.file[0].fileId,
                        ),
                    );
                },
                icon: "SendDown",
            });
        } else {
            items.push({
                label: "thirdPayments.download.detail",
                onClick: () => {
                    dispatch(
                        thirdPaymentActions.downloadFileTransaction(
                            "pdf",
                            [],
                            data.typePayment,
                            data.file[0].fileName,
                            idTransaction,
                            data.reference,
                            data.dateProcess,
                            transactionOrder,
                            amount?.currency,
                            idTransactionStatus,
                            accountName,
                            this.getStatusTransaction(),
                            data.file[0].fileId,
                        ),
                    );
                },
                icon: "SendDown",
            });
        }

        return items;
    };

    render() {
        const { request, isDesktop, dispatch, accounts } = this.props;
        const { transaction } = request;
        const { data, idTransaction, idTransactionStatus, transactionStatusName, totalAmount } = transaction;
        const { debitAccount, processedFileData, reference, dateProcess, isExport, amount } = data;

        const { currency } = amount;

        let accountName = null;
        if (!isExport) {
            if (accounts.length > 0) {
                const loggedUserAccount = accounts.find((account) => debitAccount.includes(account?.idProduct));
                if (isDesktop) {
                    accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
                } else {
                    accountName = `${accountUtils.getAccountNumber(loggedUserAccount?.cbu)} ${
                        loggedUserAccount?.productType
                    } ${i18nUtils.get(`currency.label.${loggedUserAccount.currency}`)}`;
                }
            }
        } else {
            accountName = debitAccount;
        }
        const paymentThirdPartiesFunctionalities = configUtils.getBoolean(
            "frontend.show.paymentThirdParties.functionalities",
            false,
        );

        if (isDesktop) {
            return (
                <>
                    <Card
                        className="mb-0"
                        title={
                            <div className="thirdpayment__card-title">
                                {data.dateProcess !== undefined && (
                                    <div className="thirdpayment__date">
                                        <I18n
                                            id="payments.thirdPayment.table.dateProcess"
                                            componentProps={{ className: "thirdpayment__date-info" }}
                                        />
                                        <FormattedDate date={dateProcess} dateFormat="dd/MM/yyyy" />
                                    </div>
                                )}
                                <div className="thirdpayment__reference">
                                    <I18n
                                        id="payments.thirdPayment.table.reference"
                                        componentProps={{ className: "thirdpayment__reference-info" }}
                                    />
                                    <span className="thirdpayment__reference-data">{reference}</span>
                                </div>
                            </div>
                        }
                        content={
                            <div className="thirdpayment__card-content">
                                <div className="thirdpayment__id">
                                    <I18n
                                        id="payments.thirdPayment.table.id"
                                        componentProps={{ className: "thirdpayment__id-info" }}
                                    />
                                    <span className="thirdpayment__id-data">
                                        {idTransaction.substring(0, 8).toUpperCase()}
                                    </span>
                                </div>
                                {processedFileData && processedFileData.validLines && (
                                    <div className="thirdpayment__order">
                                        <I18n
                                            id="payments.thirdPayment.table.linesNumber"
                                            componentProps={{ className: "thirdpayment__order-info" }}
                                        />
                                        <span className="thirdpayment__order-data">{processedFileData.validLines}</span>
                                    </div>
                                )}
                            </div>
                        }
                        bottom={
                            <div className="thirdpayment__card-bottom">
                                <I18n
                                    id="payments.thirdPayment.table.account"
                                    componentProps={{ className: "thirdpayment__debit-info" }}
                                />
                                <span>{accountName}</span>
                            </div>
                        }
                        rightContent={
                            <div className="thirdpayment__card-right">
                                <div className="thirdpayment__balance">
                                    <FormattedAmount
                                        currency={currency}
                                        quantity={totalAmount}
                                        className="thirdpayment__balance-currency"
                                    />
                                    <InfoTag
                                        type="info"
                                        message={this.getStatusTransaction()}
                                        tagBackground={thirdPaymentUtils.statusTagColor(
                                            transactionStatusName?.toUpperCase() || idTransactionStatus,
                                        )}
                                        tagClass="align-self-flex-end"
                                        moreStyles={{
                                            color: "#072229",
                                        }}
                                    />
                                </div>
                                <div className="thirdpayment__menu">
                                    {idTransactionStatus === "PENDING" ||
                                    (paymentThirdPartiesFunctionalities && idTransactionStatus === "PROCESSING") ? (
                                        <ContextMenu
                                            isDesktop={isDesktop}
                                            items={[
                                                {
                                                    label: "thirdPayments.decline",
                                                    onClick: () => {
                                                        dispatch(
                                                            thirdPaymentActions.setPageToGoBack(
                                                                "/payThirdParties/list",
                                                            ),
                                                        );
                                                        dispatch(thirdPaymentActions.getTransaction(idTransaction));
                                                        this.cancelTransaction();
                                                    },
                                                    icon: "Error",
                                                },
                                            ]}
                                        />
                                    ) : (
                                        <div className="thirdpayment__hidden-menu">&nbsp;</div>
                                    )}
                                </div>
                            </div>
                        }
                    />
                </>
            );
        }
        return (
            <CardContainer className="mt-0">
                <Card
                    className="mt-0 mx-1"
                    title={
                        <div className="thirdpayment__card-title">
                            <div className="space-between w-100">
                                <div>
                                    <div className="thirdpayment__reference">
                                        <I18n
                                            id="payments.thirdPayment.table.reference"
                                            componentProps={{ className: "thirdpayment__reference-info" }}
                                        />
                                        <span className="thirdpayment__reference-data">{reference}</span>
                                    </div>
                                    <div className="thirdpayment__id">
                                        <I18n
                                            id="payments.thirdPayment.table.id"
                                            componentProps={{ className: "thirdpayment__id-info" }}
                                        />
                                        <span className="thirdpayment__id-data">
                                            {idTransaction.substring(0, 8).toUpperCase()}
                                        </span>
                                    </div>
                                </div>
                                <div className="thirdpayment__menu">
                                    <ContextMenu isDesktop={isDesktop} items={this.getItemsContextMenuMobile()} />
                                </div>
                            </div>
                            <hr className="mr-0" />
                        </div>
                    }
                    content={
                        <div className="thirdpayment__card-content">
                            <div className="thirdpayment__state">
                                <I18n
                                    id="payments.thirdPayment.table.status"
                                    componentProps={{ className: "thirdpayment__state-info" }}
                                />
                                <InfoTag
                                    type="info"
                                    message={thirdPaymentUtils.getThirdPaymentDisplayStatus(transaction)}
                                    tagBackground={thirdPaymentUtils.statusTagColor(
                                        transactionStatusName?.toUpperCase() || idTransactionStatus,
                                    )}
                                    tagClass="align-self-flex-end"
                                    moreStyles={{
                                        color: "#072229",
                                    }}
                                />
                            </div>
                            {data.dateProcess !== undefined && (
                                <div className="thirdpayment__date">
                                    <I18n
                                        id="payments.thirdPayment.table.dateProcess"
                                        componentProps={{ className: "thirdpayment__date-info" }}
                                    />
                                    <FormattedDate date={dateProcess} dateFormat="dd/MM/yyyy" />
                                </div>
                            )}
                            {processedFileData && processedFileData.validLines && (
                                <div className="thirdpayment__order">
                                    <I18n
                                        id="payments.thirdPayment.table.linesNumber"
                                        componentProps={{ className: "thirdpayment__order-info" }}
                                    />
                                    <span className="thirdpayment__order-data">{processedFileData.validLines}</span>
                                </div>
                            )}
                            <div className="thirdpayment__debit">
                                <I18n
                                    id="payments.thirdPayment.table.account"
                                    componentProps={{ className: "thirdpayment__debit-info" }}
                                />
                                <span className="thirdpayment__debit-data">{accountName}</span>
                            </div>
                        </div>
                    }
                    rightContent={
                        <div className="thirdpayment__card-right">
                            <div className="thirdpayment__balance">
                                <FormattedAmount
                                    currency={currency}
                                    quantity={totalAmount}
                                    className="thirdpayment__balance-currency"
                                    showAbbreviature={false}
                                />
                            </div>
                        </div>
                    }
                />
            </CardContainer>
        );
    }
}

const mapStateToProps = (state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    accounts: accountsSelectors.getAccounts(state),
    loggedUser: sessionSelectors.getUser(state),
    transactionLines: transactionLinesSelectors.getTransactionLines(state),
});

export default connect(mapStateToProps)(ThirdPaymentItem);
